import type React from "react";

import { ButtonUI } from "../../../../components/Button/Button";
import { FormGroupUI } from "../../../../components/FormGroup/FormGroup";
import { FormGroupLabelUI } from "../../../../components/FormGroupLabel/FormGroupLabel";
import { LoadingUI } from "../../../../components/Loading";
import {
  type EmailTemplate,
  type EmailTemplateSearchInput,
  useEmailTemplatesRestApi,
} from "../../../../hooks/useEmailTemplatesRestApi";

interface EmailTemplateSelectModalProps {
  onClose: () => void;
  onSelect: (template: EmailTemplate) => void;
  filter?: EmailTemplateSearchInput;
}

export const EmailTemplateSelectModal: React.FC<
  EmailTemplateSelectModalProps
> = ({ onClose, onSelect, filter }) => {
  const {
    error,
    data,
    loading: isLoading,
  } = useEmailTemplatesRestApi({
    filter: filter || undefined,
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-[600px] max-h-[80vh] overflow-y-auto">
        <FormGroupUI className="mb-4">
          <FormGroupLabelUI className="w-full">
            テンプレート選択
          </FormGroupLabelUI>
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
        </FormGroupUI>
        <div className="space-y-4">
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="space-y-2">
              {isLoading ? (
                <div className="flex items-center justify-center py-4">
                  <LoadingUI type="Grid" />
                </div>
              ) : error ? (
                <div className="text-red-500 text-center py-4">
                  エラーが発生しました。もう一度お試しください。
                </div>
              ) : (
                <>
                  <div className="text-sm text-gray-600 mb-2">
                    検索結果: {data?.emailTemplates.items.length ?? 0}件
                  </div>
                  {data?.emailTemplates.items.length === 0 ? (
                    <div className="text-gray-500 text-center py-4">
                      テンプレートがありません
                    </div>
                  ) : (
                    data?.emailTemplates.items.map(template => (
                      <div
                        key={template.id}
                        className="border rounded-lg p-4 hover:bg-gray-50 cursor-pointer"
                        onClick={() => onSelect(template as EmailTemplate)}
                      >
                        <h3 className="font-medium">{template.name}</h3>
                      </div>
                    ))
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <ButtonUI
            type="button"
            color="primary"
            onClick={onClose}
            isOutline
            className="mr-2"
          >
            キャンセル
          </ButtonUI>
        </div>
      </div>
    </div>
  );
};
